<script setup>
import axios from 'axios';
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n'; // Import i18n for locale
import { usePage } from '@inertiajs/vue3'; // Import page context if necessary

const service_header = ref(null);
const { locale, t } = useI18n();
const page = usePage();

const loadMoreText = ref(true);

async function getServicePageHeader() {
    try {
        const res = await axios.get('/service-page-header-data');
        service_header.value = res.data || {}; // Ensure the response is an object
    } catch (error) {
        console.error('Error fetching service page header:', error);
    }
}

const loadMore = () => {
    loadMoreText.value = !loadMoreText.value; // Toggle loadMoreText
};

onMounted(() => {
    getServicePageHeader();
});
</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 mx-auto lg:pt-16 pt-8">
            <div class="pb-4 wow animate__animated animate__fadeInLeft">
                <!-- Title -->
                <h1 class="sm:w-1/2 w-full text-center text-black leading-tight mx-auto font-roboto title-font xl:text-[44px] lg:text-[36px] sm:text-[28px] text-xl mt-4 sm:mb-6 mb-4"
                    v-html="locale === 'BN' ? service_header?.bn_title : service_header?.title"></h1>

                <!-- Divider -->
                <div class="mx-auto border-[3.5px] border-transparent border-t-[#1cbed1] w-36"></div>

                <!-- Content -->
                <div v-if="page.url === '/services'" class="2xl:px-28 xl:px-20 lg:px-12">
                    <!-- Truncated Content -->
                    <p v-if="service_header" v-show="loadMoreText"
                        class="text-center lg:text-lg text-base text-black mt-3" v-html="locale === 'BN'
                            ? (service_header?.bn_content || '').slice(0, 260)
                            : (service_header?.content || '').slice(0, 260)"></p>

                    <!-- Full Content -->
                    <p v-if="service_header" v-show="!loadMoreText" class="text-black lg:text-lg text-base mt-3"
                        v-html="locale === 'BN' ? service_header?.bn_content : service_header?.content"></p>

                    <!-- Button to Toggle Text -->
                    <button v-if="service_header?.content?.length > 350" @click="loadMore"
                        class="text-[#1565C0] mx-auto flex justify-center items-center text-center mt-3">
                        {{ loadMoreText ? t('partner.show_more') : t('partner.show_less') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
